import React from "react";

const Spinner = () => {
  return (
    <>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          border: "3.5px solid #f0f0f0",
          borderTopColor: "rgba(235,148,10,1)",
          animation: "spin 0.9s linear infinite",
        }}
      />
    </>
  );
};

export default Spinner;
